
// (function(){
    //Helper function: similar to _.extend
    function _extend(obj1, obj2){
        for(var name in obj2){
            obj1[name] = obj2[name];
        }
        return obj1;
    }
    //Helper function: similar to jQuery.param (simplified)
    function _param(obj){
        var parts = [];
        for(var key in obj){
            var v = obj[key];
            v = (v === null || v === undefined) ? '' : v;
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
        }
        return parts.join('&').replace(/%20/g, '+');
    }
    
/**
 *  Handles the OAuth procedure
 *  - opens a popup that handles the oauth procedure
 *  - listens to the 'event' that is generated when the oauth procedure has been completed
 *  
 *  Note: this component is written as a standalone component so that it can be used in other sites, 
 *         i.e. it has no dependencies on external libraries like jQuery and underscore, nor does it need the rest of oanl-spa.
 *         It is however fully compatible with oanl-spa.
 */    
    const OauthComponent = function(options){
        this._options = _extend( this._defaultOptions(), options || {});
        this._messages = {};
        this._popupData = null;
        this._init();
    };
    
    var methods = {
        _init: function(){
            
        },
        _defaultOptions : function(){
            return {
                action        : 'link',
                mode          : 'popup',
                oauthDomain   : null,
                oauthStartUrl : '/oauth/start/provider/{{provider}}/action/{{action}}/callback/{{callback}}',
                oauthParams   : {},
                prefix        : 'oanl_',
                popupId       : 'remotelogin',
                popupOptions  : null,
                onOAuthOpen   : null,
                onOAuthComplete : null,
                onOAuthClose    : null
            };
        },
        getOption: function(name, defaultValue){
            if(this._options.hasOwnProperty(name)){
                return this._options[name];
            } else {
                return defaultValue;
            }
        },
        setOption: function(name, value){
            this._options[name] = value;
            return this;
        },
        _createUniqueKey: function(){
            return (new Date()).getTime();
        },
        start: function(provider, options){
            if(!provider){
                throw 'No provider provided';
                return false;
            }
            if(this._popup){
                throw 'Popup is already open';
                return false;
            }
            const _options = Object.assign({
                params : null,
                mode: 'popup'
            },options || {});
            
            var _self    = this,
                key      = this._createUniqueKey(),
                callback = '_oauth_callback'+key,
                domain   = this.getOption('oauthDomain'),
                baseUrl  = this.getOption('oauthStartUrl'),
                params   = this.getOption('oauthParams') || {},
                action   = this.getOption('action') || '';
            
            if(_options.params){
                _extend(params, _options.params);
            }
            if(_options.mode === 'inline'){
                this.setOption('mode', 'inline');
            }
        
            if(!baseUrl){
                throw 'OAuth url is not configured';
                return false;
            }
            if(domain){
                baseUrl = domain + baseUrl;
            }
            
            var url = baseUrl.replace('{{provider}}', provider)
                             .replace('{{action}}', action)
                             .replace('{{callback}}', key);
            if(params && Object.keys(params).length > 0){
                //TODO: add extra parameters
                url += (url.indexOf('?') === -1? '?':'&') + _param(params);
            }
            this._popupData = {
                provider : provider,
                url      : url,
                action   : action,
                params   : params
            };
            this._openPopup(url, callback);
        
        },

        _usesInlineMode: function(){
            return this.getOption('mode') === 'inline';
        },
    
        _openPopup: function(url, callback){
            if(this._usesInlineMode()){
                url += (url.indexOf('?') === -1? '?':'&') + _param({mode: 'inline'});
                window.location.href = url;
                return;
            }
            //TODO: use options.popupOptions
            var _self   = this,
                popupId = (this.getOption('prefix')||'')+(this.getOption('popupId')||'');
            this._popup = window.open(url, popupId, "toolbar=no, location=yes, status=no, menubar=no, scrollbars=yes, resizable=no, width=800, height=700");
            this._handlePopupOpen();
            var closeListener = window.setInterval(function() {
                try {
                    if (_self._popup == null || _self._popup.closed) {
                        _self._popup = null;
                        _self._handlePopupClose();
                        _self._popupData = null;
                        //Remove listener
                        window.clearInterval(closeListener);
                    }
                } catch (e) {
                }
            }, 100);
            
            var messageListener = window.addEventListener('message', function(e){
                var originDomain = _self.getOption('oauthDomain');
                if(originDomain && originDomain !== e.origin ){
//                    console.warn('Message ignored (wrong origin');
                    return;
                }
                var text = e.data,
                    isCallback = text.substr( 0, callback.length) === callback; //.startsWith()
                if(!isCallback){
//                    console.warn('Message ignored (no callback)');
                    return;
                }
                var data = JSON.parse(text.substr(callback.length));
                
                window.clearInterval(closeListener);
                window.removeEventListener('message', messageListener);
                window.setTimeout(function(){
                    _self._handleOauthComplete(data);
                    _self._popupData = null;
                }, 100);
            });
            
//            var doneListener = window.setInterval(function() {
//                try {
//                    if (_self._popup !== null && !_self._popup.closed) {
//                        if(_self._popup[callback]){
//                            var data = _self._popup[callback]();
//                            //Remove listeners
//                            window.clearInterval(closeListener);
//                            window.clearInterval(doneListener);
//                            window.setTimeout(function(){
//                                _self._handleOauthComplete(data);
//                            }, 100);
//                        }
//                    }
//                } catch (e) {
//                }
//            }, 2000);       
        },
/**
 * Called after the popup has been opened
 * @returns {undefined}
 */        
        _handlePopupOpen: function(){
            var handler = this.getOption('onOAuthOpen');
            if(handler){
                handler( this._popupData);
            }
        },
/**
 * Handle the closing of the oauth popup
 * @returns {undefined}
 */        
        _handlePopupClose: function(){
//console.warn('Popup was closed without authorisation');
            //As the popup has already been closed, there is not really anything to do here
            //TODO: use user defined handler
            var handler = this.getOption('onOAuthClose');
            if(handler){
                handler(this._popupData);
            }
            
        },
        _handleOauthComplete: function(data){
//console.warn('OAuth has completed with data : ', data);
            this._popup.close();
            this._popup = null;
            
            data = data || {};
            
            //TODO: use user defined handler
            var handler = this.getOption('onOAuthComplete');
            if(handler){
                if(handler(data, this._popupData) === false){
                    return;
                }
            }
            
            if(data.redirect){
                window.location = data.redirect;
                return;
            } else if(data.reload){
                window.location.reload(true);
                return;
            }
        }
    };
    _extend(OauthComponent.prototype, methods);
// })();

export default OauthComponent